export enum DividerType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Stepper = 'stepper',
  Highlight = 'highlight'
}

export enum DividerFill {
  Solid = 'solid',
  Gap = 'gap'
}

export enum DividerOrientation {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}

export enum DividerWidth {
  Default = 'default',
  Thick = 'thick'
}
